import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, BehaviorSubject, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { DefaultParams } from '../../_shared/interfaces/defaultParams';

import { UtilService } from '../../_shared/services/util.service';

import { Company } from './company.model';

interface ExtendedDefaultParams extends DefaultParams {
  by_commercial_name?: any;
  by_country?: any;
}

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private apiUrl = environment.apiEndpoint + 'companies';

  constructor(private http: HttpClient, private utilService: UtilService) {}

  private companySelectorSubject$ = new BehaviorSubject<any>('');

  reloadCompaniesSelector(data: any) {
    this.companySelectorSubject$.next(data);
  }

  getCompaniesSelector(): Observable<any> {
    return this.companySelectorSubject$.asObservable();
  }

  getFilterCriteria() {
    const defaultParams: ExtendedDefaultParams = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'commercial_name',
    };

    return defaultParams;
  }

  getCompanies(params = null): Observable<any> {
    if (!params) {
      params = this.getFilterCriteria();
    }

    const queryParams = new HttpParams({ fromObject: params });

    return this.http.get(this.apiUrl, { params: queryParams }).pipe(
      map((resp) => {
        if (resp['data']) {
          return {
            data: this.utilService.cleanItemsCache(resp['data'], 'logo'),
            meta: this.utilService.getItemsMetaData(resp, this.getFilterCriteria()),
          };
        } else {
          return resp;
        }
      })
    );
  }

  getCompany(id: string, params = null): Observable<Company> {
    const queryParams = new HttpParams({ fromObject: params });

    // If we want to update the obj
    return this.http
      .get<Company>(`${this.apiUrl}/${id}`, {
        params: queryParams,
      })
      .pipe(
        map((resp) => {
          resp.logoUrl = this.utilService.cleanItemCache(resp, 'logo');
          return resp;
        })
      );
  }

  // Save / Update
  saveCompany(companyId: string, company: Company, photo = null): Observable<Company> {
    const formData = new FormData();

    // Create and photo evaluated
    if (!companyId && photo) {
      // Store form name as "file" with file data
      formData.append('file', photo, photo.name);
    }

    for (let key in company) {
      // Required when using new FormData
      if (key === 'offices' || key === 'time_zone') {
        formData.append('company[' + key + ']', JSON.stringify(company[key]));
      } else {
        if (Array.isArray(company[key])) {
          company[key].forEach((value) => formData.append('company[' + key + '][]', value));
        } else {
          formData.append('company[' + key + ']', company[key]);
        }
      }

      /*if (Array.isArray(company[key])) {
        console.log(key);

        if (key === 'offices' || key === 'time_zone') {
          formData.append('company[' + key + ']', JSON.stringify(company[key]));
        } else {
          company[key].forEach((value) => formData.append('company[' + key + '][]', value));
        }

        // company[key].forEach((value) => formData.append('company[' + key + '][]', value));
      } else {
        console.log('normal');

        formData.append('company[' + key + ']', company[key]);
      }*/
    }

    if (!companyId) {
      return this.http.post<Company>(`${this.apiUrl}`, formData);
    } else {
      return this.http.put<Company>(`${this.apiUrl}/${companyId}`, formData);
    }
  }

  updateCompanyLogo(companyId, photo): Observable<any> {
    const formData: FormData = new FormData();

    // Store form name as "file" with file data
    formData.append('file', photo, photo.name);
    formData.append('company[id]', companyId);

    return this.http.put<Company>(`${this.apiUrl}/${companyId}`, formData);
  }
}
